import AddIcon from "@mui/icons-material/Add";
import { Fab } from "@mui/material";
import { useNavigate } from "react-router";
import { PageContent } from "../../components/core/PageContent/PageContent";
import { PageHeader } from "../../components/core/PageHeader/PageHeader";
import { useBoardPermission } from "../../hooks/useBoardPermission";
import { dictionary } from "../../utils/core/dictionary";
import { BoardList } from "./BoardList";

export function BoardPage() {
  const navigate = useNavigate();
  const { isAdmin, canCreateBoard } = useBoardPermission();
  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(`/board/create`);
      }}
    >
      <AddIcon />
    </Fab>,
  ];

  return (
    <>
      <PageHeader
        title={dictionary.BOARDS}
        buttons={canCreateBoard ? headerButtons : null}
        xs={6}
      />
      <PageContent>
        <BoardList isAdmin={isAdmin} canCreate={canCreateBoard} />
      </PageContent>
    </>
  );
}
